module.exports = __webpack_public_path__ + "img/TG.96ab0d31.svg";